import { render, staticRenderFns } from "./SharePointIntegrationCredentials.vue?vue&type=template&id=d33b56e0&scoped=true"
import script from "./SharePointIntegrationCredentials.vue?vue&type=script&lang=js"
export * from "./SharePointIntegrationCredentials.vue?vue&type=script&lang=js"
import style0 from "./SharePointIntegrationCredentials.vue?vue&type=style&index=0&id=d33b56e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33b56e0",
  null
  
)

export default component.exports